import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Sidebar } from '@ovpn/ui';
import { useSidebarInitialState } from '@ovpn/ui/sidebar';

import { selectIsOwnerAccount, useLayout } from '@cloud/shared';

import { SidebarFooter } from './SidebarFooter';
import { SidebarHeader } from './SidebarHeader';
import { SidebarLinks } from './SidebarLinks';
import { AppTenantSwitcher, SingleTenantBanner } from './TenantSwitcher';
import { sidebarOffset } from './utils';

export function AppNavigation() {
    const isMultiTenant = useSelector(selectIsOwnerAccount);

    const initialState = useSidebarInitialState();
    const [open, setOpen] = useState(initialState);
    const { isMobile, isTablet } = useLayout();

    useEffect(() => {
        if (isMobile) {
            sidebarOffset.setNone();
        } else if (open) {
            sidebarOffset.setDesktop();
        } else {
            sidebarOffset.setTablet();
        }
    }, [isMobile, open]);

    return (
        <Sidebar
            appearance="dark"
            header={<SidebarHeader />}
            footer={<SidebarFooter />}
            onChange={setOpen}
            onOpen={() => {
                if (isTablet) {
                    sidebarOffset.setTablet();
                } else {
                    sidebarOffset.setDesktop();
                }
            }}
            onClose={sidebarOffset.setTablet}
        >
            {isMultiTenant ? <AppTenantSwitcher /> : <SingleTenantBanner />}
            <SidebarLinks />
        </Sidebar>
    );
}
